// extracted by mini-css-extract-plugin
export default {"returnRow":"PaymentMethodForm_returnRow__8t9ds","returnArrow":"PaymentMethodForm_returnArrow__eHfY4","paymentMethodName":"PaymentMethodForm_paymentMethodName__S0Xcz"};